import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import useWorkspaceNavigate from '../../hooks/useWorkspaceNavigate';
import { useWorkspaceOptional } from '../../context/WorkspaceContext';

/**
 * Router Link that keeps the focused floating workspace window in sync.
 * Falls back to a normal <Link> outside workspace mode.
 */
const WorkspaceLink = forwardRef(function WorkspaceLink(
  { to, children, className, onClick, ...props },
  ref,
) {
  const workspace = useWorkspaceOptional();
  const navigate = useWorkspaceNavigate();

  if (!workspace) {
    return (
      <Link ref={ref} to={to} className={className} onClick={onClick} {...props}>
        {children}
      </Link>
    );
  }

  const href = typeof to === 'string' ? to : '#';

  return (
    <a
      ref={ref}
      href={href}
      className={className}
      onClick={(event) => {
        onClick?.(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        navigate(to);
      }}
      {...props}
    >
      {children}
    </a>
  );
});

export default WorkspaceLink;